var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailCreatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#3F4F68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email_created_clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0304 22.0303C12.7376 22.3232 12.2627 22.3232 11.9698 22.0303C11.6769 21.7374 11.6769 21.2626 11.9698 20.9697L13.9698 18.9697L15.0304 20.0303L13.0304 22.0303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9698 22.0303L20.9698 20.0303L22.0304 18.9697L24.0304 20.9697C24.3233 21.2626 24.3233 21.7374 24.0304 22.0303C23.7376 22.3232 23.2627 22.3232 22.9698 22.0303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 13C9.25 12.0335 10.0335 11.25 11 11.25H25C25.9665 11.25 26.75 12.0335 26.75 13V23C26.75 23.9665 25.9665 24.75 25 24.75H11C10.0335 24.75 9.25 23.9665 9.25 23V13ZM10.75 23V13.7954L16.056 19.1014C17.1299 20.1753 18.8711 20.1753 19.9451 19.1014L25.25 13.7964V23C25.25 23.1381 25.1381 23.25 25 23.25H11C10.8619 23.25 10.75 23.1381 10.75 23ZM11.8259 12.75H24.1751L18.8844 18.0407C18.3962 18.5289 17.6048 18.5289 17.1166 18.0407L11.8259 12.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email_created_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCreatedIcon);
export default __webpack_public_path__ + "static/media/email-created-icon.84a483fd.svg";
export { ForwardRef as ReactComponent };